import { Accordion } from '@mui/material';

import { styled } from '../../../theme/stitches.config';

export const StyledAccordion = styled(Accordion, {
  '&.MuiAccordion-root': {
    marginTop: 0,
    '.MuiAccordionSummary-root': {
      paddingRight: 16,
    },
  },
});

export const StyledContainer = styled('section', {
  boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.05)',
  marginTop: 16,
  padding: 16,
  paddingRight: 0,
});
